import { useRouter } from 'vue-router'
import api from '@/api'
import { useUserStore, useBookStore } from '@/stores'

export function useLogout() {
  const router = useRouter()

  const userStore = useUserStore()
  const bookStore = useBookStore()

  function logout() {
    api.user.logout().then(async user => {
      await userStore.clear()
      userStore.loggedOutData = user
      bookStore.clear()
      // TODO: ログアウト完了ページへ飛ばす
      router.push('/logged-out')
    }).catch(err => {
      // サーバサイドのセッションが切れていることもあるので、その場合はブラウザのユーザーを削除する
      console.log('強制ログオフ');
      userStore.clear()
      bookStore.clear()
      location.href = `/`
    })

  }

  return { logout }
}
